import React, {useEffect, useRef, useState} from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../hooks/redux';
import { RootState } from '../store';

import {
    Label as AlchemyLabel,
    Button as AlchemyButton,
    Textarea as AlchemyTextarea,
    RadioButtons as AlchemyRadioButtons,
    Switch as AlchemySwitch
} from '@amzn/alchemy-components-react';

// Import from slices instead of actions
import { addMessage } from '../slices/messageQueueSlice';
import { showModal } from '../slices/feedbackModalSlice';
import { FeedbackApiService } from '../api';
import i18n from "../i18n";

export default function() {
    // load user detail here
    const currentUser = useSelector((state: RootState) => state.user)
    // load modal status here
    const isVisible = useSelector((state: RootState) => state.feedbackModal)
    const dispatch = useAppDispatch()

    const [feedbackType, setFeedbackType] = useState("like");
    const [feedbackPlaceHolder, setFeedbackPlaceHolder] = useState('feedback:like-description')
    const feedbackCommentRef = useRef('')

    const contacts = [
        {label: `${i18n.t('feedback:contact-myself')}: ${currentUser.login}`, value: currentUser.login},
        {label: `${i18n.t('feedback:contact-my-proxy')}: ${currentUser.managerLogin}`, value: currentUser.managerLogin}
    ]
    const defaultContact = contacts[0].value

    const attitudes = [
        { label: i18n.t('feedback:like'), value: "1"},
        { label: i18n.t('feedback:dislike'), value: "2" },
    ]

    const [contactMe, setContactMe] = useState(true)
    const contactRef = useRef(defaultContact)
    // TODO: Improve: reset user as default contact
    useEffect(() => {
        contactMe && (contactRef.current = defaultContact)
    }, [currentUser, contactMe])

    const fbkApi = new FeedbackApiService()

    const handleSubmit = (e: React.SyntheticEvent) => {
        async function addFeedback() {
            const resp: any = await fbkApi.addFeedback(feedbackType, currentUser.login, feedbackCommentRef.current, contactRef.current);
            // dispatch message using the slice action
            dispatch(addMessage({
                id: Date.now().toString(),
                icon: "check", // Adding required icon property
                title: i18n.t('feedback:succeed-title'),
                text: i18n.t('feedback:succeed-text'),
                duration: 5000  // Adding required duration property (5 seconds)
            }));
        }
        addFeedback();
        resetForm()
    }

    const resetForm = () => {
        dispatch(showModal(false));
        setFeedbackType("like")
        feedbackCommentRef.current = ''
        setContactMe(true)
        contactRef.current = defaultContact
    }

    const handleInput = (inputValue: string) => {
        feedbackCommentRef.current = inputValue
    }

    const handleChange = (changeValue: string) => {
        switch (changeValue) {
            case "2":
                setFeedbackType("dislike")
                setFeedbackPlaceHolder('feedback:dislike-description')
                break;
            default:
                setFeedbackPlaceHolder('feedback:like-description')
                break;
        }
    }

    const handleContactMeChecked = (ev: React.SyntheticEvent) => {
        setContactMe((ev.target as any).checked)
        !(ev.target as any).checked && (contactRef.current = '')
    }

    const handleContactChanged = (ev: React.SyntheticEvent) => {
        contactRef.current = (ev.target as any).value
    }

    const showHideClassName = isVisible ? "bookmark-modal display-block" : "bookmark-modal display-none"
    return (
        isVisible &&
        <div className={showHideClassName}>
            <div className="bookmark-modal-main">
                <div className='bookmark-modal-header'>
                    <div>{i18n.t('feedback:title')}</div>
                    <div style={{height: "24px"}} onClick={resetForm}><Icon.X size="24" /></div>
                </div>
                <div className='bookmark-modal-body'>
                    <div className='basic-info'>
                        <div><AlchemyLabel>{i18n.t('feedback:type-description')}</AlchemyLabel></div>
                        <AlchemyRadioButtons
                            name="feedbackType"
                            variant="horizontal"
                            value='1'
                            buttons={attitudes}
                            onChange={(e) => handleChange(e.target.value)}
                        ></AlchemyRadioButtons>
                        <AlchemyTextarea 
                            label=""
                            name="comment"
                            placeholder={i18n.t(feedbackPlaceHolder)}
                            rows={2}
                            notResizable={true}
                            maxlength={240}
                            onInput = {(e) => handleInput(e.target.value)}
                        />
                        <AlchemySwitch className='d-flex justify-content-start' label={i18n.t('feedback:contact-me')} checked={contactMe} onChange={handleContactMeChecked}/>
                        <div className='pt-1'>{i18n.t('feedback:contact-me-explanation')}</div>
                        <AlchemyRadioButtons disabled={!contactMe}
                            value={contactRef.current}
                            buttons={contacts}
                            onChange={handleContactChanged}
                        />
                    </div>
                </div>
                <div className='bookmark-modal-footer'>
                    <AlchemyButton variant="action" onClick={handleSubmit}>{i18n.t('feedback:submit')}</AlchemyButton>
                    <AlchemyButton onClick={resetForm}>{i18n.t('universal:cancel')}</AlchemyButton>
                </div>
            </div>
        </div>
    )
}
